import { useContext, useEffect, useRef } from 'react';
import { SignalRContext } from 'contexts/signalR';
import { SignalREvents } from 'constants/signalR';

export const useSignalREvent = (event: SignalREvents, callback: (arg: string) => void): void => {
  const { connection, established } = useContext(SignalRContext);
  const callbackRef = useRef(callback);

  useEffect(() => {
    callbackRef.current = callback;
  });

  useEffect(() => {
    if (!connection) return undefined;
    const handler = (data: string): void => { callbackRef.current(data); };
    connection.on(event, handler);
    return () => {
      connection.off(event, handler);
    };
  }, [connection, established, event]);
};
